import { render } from "./About.vue?vue&type=template&id=0f1732a9&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=0f1732a9&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Keith\\Dropbox\\WebStorm\\Projects\\slumbernot\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f1732a9"]])

export default __exports__